<template>
  <div id="container" :class="{ 'dark': authStore.user.dark, 'menu_opened': authStore.user.menu_opened }" v-if="isAuthenticated">
    <LeftMenu></LeftMenu>
    <div id="content">
      <router-view/>
      <SpinnerLoader />
      <NewsWidget />
    </div>
  </div>
  <div class="auth_container" v-else>
    <router-view/>
  </div>
</template>

<script setup>
import './assets/css/style.css';
import './assets/css/style_dark.css';

import { computed, watch } from 'vue';
import LeftMenu from './components/LeftMenu.vue';
import SpinnerLoader from './components/SpinnerLoader.vue';
import NewsWidget from './components/NewsWidget.vue';
import { useAuthStore } from '@/stores/AuthStore';

const authStore = useAuthStore();
const isAuthenticated = computed(() => authStore.isAuthenticated);

watch(() => authStore.user ? authStore.user.dark : null, (newDarkValue) => {
  if (newDarkValue == 1) {
    document.body.classList.add('dark');
  } else {
    document.body.classList.remove('dark');
  }
});
</script>